import { toast } from '@/components/toast';
import InfoCircle from '@/images/InfoCircle.svg';
import { useGetStripeCustomerPortalUrl } from '@/state/products/Products';
import { HttpStatus } from '@d-id/http-status';
import mixpanel from 'mixpanel-browser';
import { useState } from 'react';
import { MaskedIcon } from '../MaskedIcon/MaskedIcon';
import CtaBanner from './CtaBanner';

const PaymentUnsuccessfulBanner = () => {
    const [disableButton, setDisableButton] = useState(false);
    const { refetch: refetchCustomerPortalUrl } = useGetStripeCustomerPortalUrl();

    async function openStripe() {
        const { data } = await refetchCustomerPortalUrl();
        if (data?.status === HttpStatus.OK) {
            window.open(data?.url);
        } else {
            toast.error({ title: 'Could not find user billing data' });
        }
    }

    const handleCta = async () => {
        mixpanel?.track('billing', { event: 'click' });
        setDisableButton(true);
        await openStripe();
        setDisableButton(false);
    };

    return (
        <CtaBanner
            icon={<MaskedIcon src={InfoCircle} size="24px" color={'#ED254E'} />}
            title="Your payment was unsuccessful."
            subtitle="To resolve this, please update your payment details."
            ctaText="Update Payment"
            onCta={handleCta}
            disableCta={disableButton}
        />
    );
};

export default PaymentUnsuccessfulBanner;
